export class Authority{
    public loginEmpCd: string
    public empTypeCd: string
    public roleSales: boolean
    public roleLeader: boolean
    public roleManager: boolean
    public roleBusinessAdmin: boolean
    public roleWorkingHoursAdmin: boolean

}
